export function isMobileBuild() {
  return process.env.REACT_APP_TARGET === 'mobile';
}
